import substr from './substr';

const getJsonFromUrl = (query = '') => {
  const result = {};

  const process = (part: string) => {
    part = part.split('+').join(' '); // + to space, regexp-free version
    const eq = part.indexOf('=');
    let key = eq > -1 ? substr(part, 0, eq) : part;
    const val = eq > -1 ? decodeURIComponent(substr(part, eq + 1)) : '';
    const from = key.indexOf('[');
    if (from === -1) {
      result[decodeURIComponent(key)] = val;
    } else {
      const to = key.indexOf(']', from);
      const index = decodeURIComponent(key.substring(from + 1, to));
      key = decodeURIComponent(key.substring(0, from));
      if (!result[key]) {
        result[key] = [];
      }
      if (!index) {
        result[key].push(val);
      } else {
        result[key][index] = val;
      }
    }
  };

  query.split('&').forEach((part: string | undefined) => {
    if (!part) {
      return;
    }
    process(part);
  });

  return result;
};

export default getJsonFromUrl;
